export default "<div>\r\n    <div class=\"text-center\">\r\n        <h3>Sin contenido</h3>\r\n    </div>\r\n</div>"